module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/back_top_03.69762c12.png";